module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/gamelift-2015-10-01.paginators.json
// module id = 2130
// module chunks = 0